import { Roles } from '@/core/constants/roleConstants';

export const menuDropdown = [
  {
    text: 'Carátula',
    icon: 'mdi-account-box-edit-outline',
    roles: ['Administrator', 'CustomerPR', 'Customer'],
    path: 'CustomerCoverDetails',
    show: false, // If false, path will be hidden to roles/chaneles setted in this object, if true (default value) it will be only shown to those roles/channels
  },
  {
    text: 'Carátula',
    icon: 'mdi-account-box-edit-outline',
    roles: ['CustomerPR', 'Customer'],
    path: 'Home',
  },
  {
    text: 'Pedidos',
    icon: 'mdi-cart-plus',
    menu: [
      {
        text: 'Nuevo pedido',
        path: 'NewShoppingCart',
        params: { doctype: 'PSDT', idq: 0 },
        channels: ['DT'],
        notRoles: [
          'Director',
          'IELDirector',
          'IELCommercialPR',
          'IELCommercialDT',
          'Subdirector',
          'IELBriefcase',
          'CreditAssistant',
          'Credit',
          'DirectorNoCommercial',
          'SubDirectorPRNoCommercial',
          'SubDirectorDTNoCommercial',
        ],
      },
      {
        text: 'Nuevo pedido',
        path: 'NewShoppingCartPR',
        params: { doctype: 'PSIU', idq: 0 },
        channels: ['PR'],
        notRoles: [
          'Director',
          'IELDirector',
          'IELCommercialPR',
          'IELCommercialDT',
          'Subdirector',
          'IELBriefcase',
          'CreditAssistant',
          'Credit',
          'DirectorNoCommercial',
          'SubDirectorPRNoCommercial',
          'SubDirectorDTNoCommercial',
        ],
      },
      {
        text: 'Pedidos especiales',
        menu: [
          {
            text: 'Carretes',
            path: 'CreateReelOrder',
            roles: [
              'CustomerPR',
              'Customer',
              'Seller',
              'Manager',
              'Submanager',
              'RegionalManager',
              'IELExpressSales',
              'DirectorNoCommercial',
              'SubDirectorPRNoCommercial',
              'SubDirectorDTNoCommercial',
              'Superuser',
              Roles.POST_SALE,
            ],
          },
          {
            text: 'Combo',
            path: 'CreateKitOrder',
            roles: [
              'CustomerPR',
              'Customer',
              'Seller',
              'Manager',
              'Submanager',
              'RegionalManager',
              'IELExpressSales',
              'DirectorNoCommercial',
              'SubDirectorPRNoCommercial',
              'SubDirectorDTNoCommercial',
              'Superuser',
              Roles.POST_SALE,
            ],
          },
          {
            text: 'Productos Nuevos PNC',
            path: 'NewShoppingCart',
            params: { doctype: 'PSNW', idq: 0 },
            channels: ['DT'],
            notRoles: [
              'Director',
              'IELDirector',
              'IELCommercialPR',
              'IELCommercialDT',
              'Subdirector',
            ],
          },
          {
            text: 'Productos Nuevos PNC',
            path: 'NewShoppingCartPR',
            params: { doctype: 'PSNW', idq: 0 },
            channels: ['PR'],
            notRoles: [
              'Director',
              'IELDirector',
              'IELCommercialPR',
              'IELCommercialDT',
              'Subdirector',
            ],
          },

          {
            text: 'Bono POP',
            path: 'NewShoppingCart',
            params: { doctype: 'PSPO', idq: 0 },
            channels: ['DT'],
            notRoles: [
              'Director',
              'IELDirector',
              'IELCommercialPR',
              'IELCommercialDT',
              'Subdirector',
            ],
          },
          {
            text: 'Bono POP',
            path: 'NewShoppingCartPR',
            params: { doctype: 'PSPO', idq: 0 },
            channels: ['PR'],
            notRoles: [
              'Director',
              'IELDirector',
              'IELCommercialPR',
              'IELCommercialDT',
              'Subdirector',
            ],
          },
          {
            text: 'Pedidos bajo cotiza',
            path: 'CreateRequestForQuotation',
            roles: [
              'Seller',
              'Customer',
              'CustomerPR',
              'Manager',
              'Submanager',
              'RegionalManager',
              'IELExpressSales',
              'DirectorNoCommercial',
              'SubDirectorPRNoCommercial',
              'SubDirectorDTNoCommercial',
              'Superuser',
              Roles.POST_SALE,
            ],
          },
        ],
        notRoles: [
          'Director',
          'IELDirector',
          'IELCommercialPR',
          'IELCommercialDT',
          'Subdirector',
          'IELBriefcase',
          'CreditAssistant',
          'Credit',
          'DirectorNoCommercial',
          'SubDirectorPRNoCommercial',
          'SubDirectorDTNoCommercial',
        ],
      },
      {
        text: 'Backorder',
        path: 'backorders',
        roles: [
          Roles.REGIONAL_MANAGER,
          Roles.SUB_MANAGER,
          Roles.MANAGER,
          Roles.SELLER,
          Roles.CUSTOMER_RETAIL,
          Roles.CUSTOMER_WHOLESALER,
          Roles.EXPRESS_SALES,
          Roles.SUPER_USER,
          Roles.POST_SALE,
        ],
      },
      {
        text: 'Cotización',
        path: 'QuoterHistory',
        notRoles: [
          'Director',
          'IELDirector',
          'IELCommercialPR',
          'IELCommercialDT',
          'Subdirector',
          'IELBriefcase',
          'CreditAssistant',
          'Credit',
          'DirectorNoCommercial',
          'SubDirectorPRNoCommercial',
          'SubDirectorDTNoCommercial',
          'IELMarketing',
        ],
      },
      {
        text: 'Estado de pedidos',
        path: 'OrderStatus',
        notRoles: ['IELMarketing'],
      },
      {
        text: 'Historial de pedidos',
        path: 'HistoryOrders',
        notRoles: ['IELMarketing'],
      },
      {
        text: 'Recordatorio carretes',
        path: 'CreateReelReminderOrder',
        roles: [
          'CustomerPR',
          'Customer',
          'Seller',
          'Manager',
          'Submanager',
          'RegionalManager',
          'IELExpressSales',
          'Superuser',
          Roles.POST_SALE,
        ],
      },
      {
        text: 'Movimientos de cuenta',
        path: 'AccountStatus',
        notRoles: [
          'Director',
          'IELDirector',
          'IELCommercialPR',
          'IELCommercialDT',
          'Subdirector',
          'IELBriefcase',
          'IELMarketing',
        ],
      },
    ],
  },
  {
    text: 'Consulta',
    icon: 'mdi-layers-search-outline',
    menu: [
      {
        text: 'Videoteca',
        path: 'MultimediaCenterVideo',
      },
      {
        text: 'Avisos de prueba CFE',
        external: true,
        event: 'testNoticesCFEAlert/show',
      },
      {
        text: 'Formatos (selectivo)',
        path: '',
        roles: ['Seller'],
      },
      {
        text: 'Promociones',
        path: '',
        external: true,
        channels: ['PR'],
      },
      {
        text: 'Promociones',
        path: '',
        external: true,
        channels: ['DT'],
      },
      {
        text: 'Catálogos',
        menu: [
          {
            text: 'Catálogo Construcción',
            path: 'https://www.iusa.com.mx/catalogo_construccion/',
            external: true,
          },
          {
            text: 'Catálogo Energia',
            path: 'https://www.iusa.com.mx/catalogo_energia/',
            external: true,
          },
        ],
      },
    ],
  },
  {
    text: 'Actualización de precios y Productos',
    icon: 'mdi-alert-circle-check-outline',
    menu: [
      {
        text: 'Archivo de precios',
        path: 'MultimediaCenter',
      },
    ],
  },
];
